__turbopack_context__.v({
  "arrow": "live-tournament-module-sass-module__WZR8xG__arrow",
  "favorites": "live-tournament-module-sass-module__WZR8xG__favorites",
  "header": "live-tournament-module-sass-module__WZR8xG__header",
  "opened": "live-tournament-module-sass-module__WZR8xG__opened",
  "tournament": "live-tournament-module-sass-module__WZR8xG__tournament",
  "tournamentName": "live-tournament-module-sass-module__WZR8xG__tournamentName",
});
